import config from '@/config';

/// Checks if the user should have mobile functionality enabled, such as mobile navigation etc.
/// Don't use this to specify mobile layouts as this is js based and comes with a delay.
/// For layouts, use CSS media queries.
export default function (): boolean {
  return !window.matchMedia(config.DESKTOP_MEDIA_QUERY).matches;
}
